import React from "react";
import {JobsCard} from "../components/JobsCard";
import jobsData from "../data/jobs.json";

export const JobsPage = () => {
  return React.createElement(
    "div",
    { className: "jobs-page" },
    React.createElement("h1", null, "Join Our Team"),
    React.createElement(
      "div",
      { className: "job-list" },
      jobsData.map(job =>
        React.createElement(JobsCard, { key: job.id, job })
      )
    )
  );
};
